import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const HOME_PATHS = new Set(["/", "/home"]);

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function homeScrollBehavior() {
  return prefersReducedMotion() ? "auto" : "smooth";
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const isHome = HOME_PATHS.has(pathname);
    const pathChanged = prevPathname.current !== pathname;
    prevPathname.current = pathname;

    if (hash && isHome) {
      const id = hash.replace("#", "");
      const behavior = homeScrollBehavior();
      const scrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior, block: "start" });
          return true;
        }
        return false;
      };
      if (!scrollToHash()) {
        requestAnimationFrame(scrollToHash);
      }
      return;
    }

    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
      }
      return;
    }

    if (isHome && !pathChanged) {
      window.scrollTo({ top: 0, left: 0, behavior: homeScrollBehavior() });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
